import { ArrowUp, ArrowDown, ArrowLeft, ArrowRight } from "lucide-react";

const dirs = [
  { key: "up", Icon: ArrowUp, row: 0, col: 1 },
  { key: "left", Icon: ArrowLeft, row: 1, col: 0 },
  { key: "down", Icon: ArrowDown, row: 1, col: 1 },
  { key: "right", Icon: ArrowRight, row: 1, col: 2 },
];

const DirectionPad = ({ onDirection, onBackspace, onClear, accent = "#FFE800", testIdPrefix = "" }) => (
  <div className="space-y-3">
    <div className="grid max-w-[180px] grid-cols-3 gap-2">
      {[0, 1, 2, 3, 4, 5].map((idx) => {
        const dir = dirs.find((d) => d.row * 3 + d.col === idx);
        if (!dir) return <div key={idx} />;
        return (
          <button
            key={dir.key}
            onClick={() => onDirection(dir.key)}
            className="border border-white/10 bg-black/60 p-2"
            style={{ color: accent }}
            data-testid={testIdPrefix ? `${testIdPrefix}-dir-${dir.key}` : undefined}
          >
            <dir.Icon className="mx-auto h-4 w-4" />
          </button>
        );
      })}
    </div>
    <div className="flex flex-wrap gap-2">
      <button onClick={onBackspace} className="border border-white/10 px-3 py-1 text-xs font-data text-gray-300">
        Backspace
      </button>
      <button onClick={onClear} className="border border-white/10 px-3 py-1 text-xs font-data text-gray-300">
        Clear
      </button>
    </div>
  </div>
);

export default DirectionPad;
